
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.603 10.73h-.72V7.256c0-.022-.004-.044-.007-.066a.577.577 0 00-.14-.38L19.953.2l-.004-.004a.574.574 0 00-.156-.121.615.615 0 00-.116-.049l-.032-.01A.591.591 0 0019.51 0H5.294c-.65 0-1.176.528-1.176 1.176v9.555h-.72c-.93 0-1.682.752-1.682 1.68v8.745c0 .928.753 1.682 1.681 1.682h.72v5.986c0 .648.528 1.176 1.177 1.176h19.412c.648 0 1.176-.528 1.176-1.176v-5.986h.72c.929 0 1.682-.753 1.682-1.682v-8.744c0-.929-.753-1.681-1.681-1.681zM5.294 1.177h13.627v6.02c0 .325.264.588.588.588h5.197v2.947H5.294V1.176zm8.856 15.96c-1.46-.509-2.41-1.316-2.41-2.593 0-1.5 1.25-2.647 3.322-2.647.991 0 1.721.209 2.242.444l-.443 1.603a4.166 4.166 0 00-1.838-.417c-.86 0-1.277.39-1.277.847 0 .56.495.808 1.63 1.238 1.55.573 2.28 1.381 2.28 2.62 0 1.472-1.133 2.724-3.545 2.724-1.003 0-1.994-.262-2.489-.535l.404-1.642c.534.274 1.355.547 2.203.547.912 0 1.395-.378 1.395-.952 0-.547-.418-.86-1.474-1.237zm-10.349-.574c0-2.997 2.138-4.666 4.796-4.666 1.03 0 1.812.209 2.164.392l-.404 1.576a4.306 4.306 0 00-1.669-.325c-1.577 0-2.801.951-2.801 2.906 0 1.76 1.042 2.867 2.815 2.867.6 0 1.264-.13 1.655-.287l.3 1.551c-.365.183-1.186.379-2.255.379-3.037 0-4.6-1.89-4.6-4.393zm20.905 11.943H5.294v-5.667h19.412v5.667zm-1.314-7.681h-2.32l-2.815-8.784h2.177l1.068 3.715c.3 1.042.574 2.045.783 3.14h.038c.222-1.056.495-2.098.795-3.102l1.121-3.753h2.112l-2.96 8.784z","fill":"#1BA7E1"}})])
          )
        }
      }
    